import Vue from "vue";
import Qs from "qs";
import axios from 'axios'
import {
    Loading
} from 'element-ui'
import router from '@/router'
import { debounce } from 'lodash';
import { BASEURL, TIMEOUT } from "./const";
// import api from "./apis"

// 在全局请求和响应拦截器中添加请求状态
let loadingInstance; //loading 实例
let needLoadingRequestCount = 0; //当前正在请求的数量

function requestModule(options) {

    this.requestOptions = Object.assign({
        baseUrl: BASEURL,
        url: null,
        name: null,
        data: null,
        cancel: true,
        loading: {
            enable: false,
            text: "",
        },
        headers: null,
        notQs: false
    }, options);
    //this.requestOptions.url = this.requestOptions.url || api[this.requestOptions.name];
    this.axiosInstance = axios.create({
        baseURL: this.requestOptions.baseUrl,
        timeout: this.requestOptions.timeout || TIMEOUT,
        changeOrigin: true, //允许跨域
        cancelToken: new axios.CancelToken(c => {
            Vue.$httpRequestList = Vue.$httpRequestList || [];
            Vue.$httpRequestList.push({
                flag: this.requestOptions.cancel,
                route: router.currentRoute,
                request: c
            });
        }),
        withCredentials: false
    });

    this.showLoading = () => {
        if (this.requestOptions.loading && this.requestOptions.loading.enabled) {
            if (!loadingInstance) {
                loadingInstance = Loading.service({
                    target: "body",
                    text: this.requestOptions.loading.text,
                    background: 'rgba(0,0,0,0.3)'
                });
            }
            needLoadingRequestCount++;
        };

    }
    this.closeLoading = () => {
        if (this.requestOptions.loading && this.requestOptions.loading.enabled) {
            needLoadingRequestCount--;
            needLoadingRequestCount = Math.max(needLoadingRequestCount, 0); // 保证大于等于0
            if (needLoadingRequestCount === 0) {
                if (loadingInstance) {
                    this.hideLoading();
                }
            }
        }
    }
    this.hideLoading = debounce(() => {
        if (loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }

    }, 300);
    this.beforeSend = () => {
        this.axiosInstance.interceptors.request.use(config => {
            if (config.data && config.method == 'post' && !this.requestOptions.notQs) {
                config.data = Qs.stringify(config.data);
            };
            if (this.requestOptions.headers) {
                let headers = config.headers ? config.headers : {};
                headers = Object.assign(headers, this.requestOptions.headers);
                config.headers = headers;
            }
            return config;
        }, error => {
            return Promise.reject(error);
        });
    }
    this.response = () => {
        this.axiosInstance.interceptors.response.use(response => {

            this.closeLoading();
            if (this.requestOptions.url) {
                let respData = response.data;
                if (respData.status == 0) {
                    return respData.returnData;
                }
                return Promise.reject(respData);
                // return response.data;
            } else {
                return Promise.reject({
                    msg: '请求地址不存在!'
                });
            };
        }, error => {
            console.log(error, "request error")
            this.closeLoading();
            return Promise.reject(error);
        });
    }
    this.post = () => {
        return this.axiosInstance.post(this.requestOptions.url, this.requestOptions.data);
    }
    this.get = () => {
        return this.axiosInstance.get(this.requestOptions.url, { params: this.requestOptions.data });
    }
    this.put = () => {
        return this.axiosInstance.put(this.requestOptions.url, this.requestOptions.data);
    }
    this.delete = () => {
        return this.axiosInstance.delete(this.requestOptions.url, this.requestOptions.data);
    }
    this.send = (method, resolve, reject) => {

        this[method]().then(result => {
            resolve(result)
        }).catch(error => {
            reject(error)
        })


    }
    this.resolve = (method) => {
        return new Promise((resolve, reject) => {
            this.send(method, resolve, reject);
        });
    }


    this.showLoading();
    this.beforeSend();
    this.response();
}
const request = (() => {
    let o = {};
    'get,post,put,delete'.split(',').forEach(key => {
        o[key] = (ops) => {
            return new requestModule(ops).resolve(key);
        };
    });
    return o;
})();
// Vue.Components = Vue.Components || {};
// Vue.Components.request = Vue.prototype.$request = request;
export default request